import { AccessTokenPayload } from '@app/core/auth/interfaces/access-token-payload';
import { UserInToken } from '@app/entities/users/interfaces/user-in-token';
import { AuthTokens } from '@app/interfaces/auth-tokens';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Selector } from '@ngxs/store';
import { AuthStateModel } from './auth-state.model';
import { AuthState } from './auth.state';
import { ImageMeta } from '@app/entities/images/interfaces/image-meta';

export class AuthSelectors {
  @Selector([AuthState])
  static authTokens(state: AuthStateModel): AuthTokens {
    return {
      token: state.token,
      refreshToken: state.refreshToken,
    };
  }

  @Selector([AuthState])
  static token(state: AuthStateModel): string | undefined {
    return state.token;
  }

  @Selector([AuthState])
  static tokenPayload(state: AuthStateModel): AccessTokenPayload | undefined {
    return state.accessTokenPayload;
  }

  @Selector([AuthState])
  static currentUser(state: AuthStateModel): UserInToken | undefined {
    if (!state.accessTokenPayload) {
      return;
    }

    return {
      user_id: state.accessTokenPayload.user_id,
      email: state.accessTokenPayload.email,
      phone: state.accessTokenPayload.phone,
      name: state.accessTokenPayload.name,
      surname: state.accessTokenPayload.surname,
      avatar: state.accessTokenPayload.avatar,
      address: state.accessTokenPayload.address,
      address_info: state.accessTokenPayload.address_info,
      zip_code: state.accessTokenPayload.zip_code,
      city: state.accessTokenPayload.city,
      country: state.accessTokenPayload.country,
    };
  }

  @Selector([AuthState])
  static currentUserAvatar(
    state: AuthStateModel,
  ): ImageMeta | null | undefined {
    return state.accessTokenPayload?.avatar;
  }

  @Selector([AuthState])
  static currentUserID(state: AuthStateModel): number | undefined {
    return state.accessTokenPayload?.user_id;
  }

  @Selector([AuthState])
  static avatarUrl(state: AuthStateModel): string | undefined {
    // return state.accessTokenPayload?.data?.avatar;
    return undefined;
  }

  @Selector([AuthState])
  static refreshToken(state: AuthStateModel): string | undefined {
    return state.refreshToken;
  }

  @Selector([AuthState])
  static isAuthenticated(state: AuthStateModel): boolean {
    return !!state.token;
    if (!state.token) {
      return false;
    }

    const jwtHelper = new JwtHelperService();
    return !jwtHelper.isTokenExpired(state.token!);
  }

  @Selector([AuthState])
  static returnUrl(state: AuthStateModel): string | undefined {
    return state.returnUrl;
  }
}
